import TiposMovimentosRotas from './tiposMovimentos/TiposMovimentosRotas'
import ParametrosRotas from './parametros/ParametrosRotas'
import ComprometimentosRotas from './comprometimentos/ComprometimentosRotas'
import ModelosRotas from './modelos/ModelosRotas'
import FiliaisRotas from './filiais/FiliaisRotas'

export default {
    path: 'admin',
    name: 'Admin',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        TiposMovimentosRotas,
        ParametrosRotas,
        ComprometimentosRotas,
        ModelosRotas,
        FiliaisRotas
    ]
}
